import { PotentialDiagram } from "./diagrams/PotentialDiagram";

export const Potential = () => (
  <section data-testid="potential-section" className="on-dark bg-[#0D1B2A] text-[#F2F3F5] py-28 md:py-44">
    <PotentialDiagram />
  </section>
);
